import {
  Checkbox,
  FormControl,
  InputAdornment,
  ListItemText,
} from "@mui/material";
import React, { useState } from "react";
import { useTheme } from "@mui/material";

import {
  StyledLabel,
  StyledPlaceholder,
  StyledSelect,
  StyledMenuItem,
} from "./CustomDropdown.styles";

export const CustomDropdown = ({
  value,
  setValue,
  label,
  data,
  Icon,
  noIcon,
  readOnly,
  placeholder,
  width,
  color,
}) => {
  const theme = useTheme();
  const [open, setopen] = useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setValue(value);
    setopen(false);
  };

  return (
    <FormControl fullWidth disabled={readOnly} sx={{ marginTop: "6px" }}>
      {label && <StyledLabel color={color}>{label}</StyledLabel>}
      <StyledSelect
        $color={color}
        $width={width}
        displayEmpty
        disabled={data?.length === 0 || readOnly}
        value={value ?? ""}
        onChange={handleChange}
        open={open}
        onClose={() => setopen(false)}
        onOpen={() => setopen(true)}
        MenuProps={{
          onClose: () => setopen(false),
        }}
        renderValue={(selected) => {
          if (selected === "" || selected === null) {
            return (
              <StyledPlaceholder color={color}>
                {placeholder || "Select"}
              </StyledPlaceholder>
            );
          }
          return selected;
        }}
        startAdornment={
          !noIcon && Icon ? (
            <InputAdornment position="start">
              <Icon sx={{ color: color || theme.palette.text.primary }} />
            </InputAdornment>
          ) : null
        }
        inputProps={{ "aria-label": "Without label" }}
      >
        {label === "Choose Customer" && (
          <StyledMenuItem value="">None</StyledMenuItem>
        )}
        {data?.map((option) => (
          <StyledMenuItem
            key={option.value}
            value={option.value}
            onClick={option.action}
          >
            {option.label}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

export const CustomMultiSelectDropdown = ({
  value = [],
  setValue,
  label,
  data,
  Icon,
  noIcon,
  readOnly,
  placeholder,
  width,
  color,
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setValue(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <FormControl fullWidth disabled={readOnly} sx={{ marginTop: "6px" }}>
      <StyledLabel color={color}>{label}</StyledLabel>
      <StyledSelect
        $color={color}
        $width={width}
        multiple
        displayEmpty
        disabled={data?.length === 0 || readOnly}
        value={value ?? []}
        onChange={handleChange}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        MenuProps={{
          onClose: () => setOpen(false),
        }}
        inputProps={{ "aria-label": "Without label" }}
        renderValue={(selected) => {
          if (!selected || selected.length === 0) {
            return (
              <StyledPlaceholder color={color}>
                {placeholder || "Select"}
              </StyledPlaceholder>
            );
          }
          return selected.join(", ");
        }}
        startAdornment={
          !noIcon && Icon ? (
            <InputAdornment position="start">
              <Icon sx={{ color: color || theme.palette.text.primary }} />
            </InputAdornment>
          ) : null
        }
      >
        {data?.map((option) => (
          <StyledMenuItem key={option.value} value={option.value}>
            <Checkbox
              sx={{ color: theme.palette.text.primary }}
              checked={value.indexOf(option.value) > -1}
            />
            <ListItemText primary={option.label} />
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};
